import { postJson } from '../lib/apiClient';

export interface FolderContentParams {
  email?: string | null;
  path: string;
  size: string;
  page: number;
}

export interface FolderRequestParams {
  path: string;
  size: string;
}

export const filesApi = {
  getFolderByPath: (path: string, email?: string | null) =>
    postJson<any>('/get-folder-by-path.php', {
      path,
      email: email || null,
    }),

  getFolderContent: ({ email, path, size, page }: FolderContentParams) =>
    postJson<any[] | string>('/get-folder-content.php', {
      email,
      path,
      size,
      page,
    }),

  getTotalFolderContent: (path: string, email?: string | null) =>
    postJson<{ total: number } | string>('/get-total-folder-content.php', {
      email,
      path,
    }),

  getFolders: ({ path, size }: FolderRequestParams) =>
    postJson<any[] | { error?: string }>('/get-folders.php', {
      path,
      size,
    }),

  getFolderNames: (path: string) =>
    postJson<any[] | string>('/get-folder-names.php', {
      path,
    }),

  moveToTrash: (id: number, email?: string | null) =>
    postJson<any>('/move-to-trash.php', {
      email,
      id,
    }),
};
